import React, { useEffect, useState } from 'react'
import SectionHeader from '../../../../Components/GeneralComponents/SectionHeader'
import NewTeamMemberModal from '../../../../Components/Team/NewTeamMemberModal'
import EditTeamModal from '../../../../Components/Team/EditTeamModal'
import { getTeamMembers } from '../../../../Requests/TeamRequests'
import TeamMembersTable from '../../../../Components/Team/TeamMembersTable'
import { useTranslation } from 'react-i18next'
import { getTeamUuid } from '../../../../utils/cookies'
import { useTeamsContext } from '../../../../Components/ContextProviders/TeamsContextProvider'
import { PencilIcon } from '@heroicons/react/24/outline'
import { useSidebar } from '../../../../Components/ContextProviders/SidebarContextProvider'
import { getSidebarPadding } from '../../../../utils/sidebar'

function Team() {
    const [teamMemberModal, setTeamMemberModal] = useState(false)
    const [editTeamModal, setEditTeamModal] = useState(false)
    const [teamMembers, setTeamMembers] = useState(null)
    const { t } = useTranslation()
    const { currentTeam } = useTeamsContext()
    const { isCollapsed } = useSidebar()

    useEffect(() => {
        getTeamMembers(getTeamUuid()).then((res) => {
            setTeamMembers(res.data["members"])
        }).catch((error) => {

        });
    }, [])



    return (
        <div className={`${getSidebarPadding(isCollapsed)} transition-all duration-300 pt-4 md:pt-12 w-full flex justify-center px-4`}>
            <div className='bg-white max-w-7xl rounded-2xl w-full h-full shadow-xl mx-8'>
                {/* Team name section with edit functionality */}
                <div className="px-6 py-4 border-b border-gray-200">
                    <div className="flex items-center gap-3">
                        <h1 className="text-2xl font-semibold text-gray-900">
                            {currentTeam?.name || 'Team'}
                        </h1>
                        <button
                            onClick={() => setEditTeamModal(true)}
                            className="inline-flex items-center p-1.5 border border-transparent rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-iavisus-100 focus:ring-offset-2"
                            title="Edit team name"
                        >
                            <PencilIcon className="h-4 w-4" aria-hidden="true" />
                        </button>
                    </div>
                    {currentTeam?.description && (
                        <p className="mt-1 text-sm text-gray-500">{currentTeam.description}</p>
                    )}
                </div>
                
                <SectionHeader title={t('Team.Header.Title')} subtitle={t('Team.Header.Subtitle')} actionTitle={t('Team.Header.ActionTitle')} actionFunction={() => { setTeamMemberModal(true) }}></SectionHeader>
                {teamMembers && <TeamMembersTable teamMembers={teamMembers}></TeamMembersTable>}
            </div>

            {teamMemberModal && <NewTeamMemberModal handleClose={() => { setTeamMemberModal(false) }}></NewTeamMemberModal>}
            {editTeamModal && currentTeam && <EditTeamModal team={currentTeam} handleClose={() => { setEditTeamModal(false) }}></EditTeamModal>}
        </div>
    )
}

export default Team
